export const getTimeRemaining = (endtime: string) => {
  const total = Date.parse(endtime) - Date.parse(Date());
  const seconds = Math.max(Math.floor((total / 1000) % 60), 0);
  const minutes = Math.max(Math.floor((total / 1000 / 60) % 60), 0);

  return {
    total,
    minutes,
    seconds,
  };
};

let timeInterval;

export const initializeClock = (
  endtime: string,
  callback: (minutes: number, seconds: number) => void
) => {
  if (timeInterval) {
    clearInterval(timeInterval);
    timeInterval = null;
  }
  const updateClock = () => {
    const t = getTimeRemaining(endtime);
    const minutes = t.minutes;
    const seconds = t.seconds;

    if (t.total <= 0) {
      clearInterval(timeInterval);
    }
    callback(minutes, seconds);
  };

  updateClock();
  timeInterval = setInterval(updateClock, 1000);
};
